// extracted by mini-css-extract-plugin
export default {"NotFound":"NotFound_NotFound__STZ-n","NotFound-content":"NotFound_NotFound-content__2yGTG"};